module.exports = __webpack_public_path__ + "static/assets/62f61da7153c7a56bfb006e67dc0a230.png";